<template>
  <el-dialog title="编辑风险策略"
             :close-on-click-modal="false"
             top="80px"
             append-to-body
             v-bind="$attrs"
             v-on="$listeners">
    <el-form label-width="120px"
             ref="formRef"
             :model="riskForm"
             :rules="formRules">
      <el-form-item label="风险等级"
                    prop="level">
        <el-select size="small"
                   filterable
                   clearable
                   v-model="riskForm.level"
                   placeholder="风险等级"
                   style="width: 200px"
                   disabled>
          <el-option v-for="item in riskOptions"
                     :label="item.label"
                     :value="item.value"
                     :disabled="item.disabled"
                     :key="item.value"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-card shadow="never">
        <template #header>
          <div class="card-header">判定策略</div>
        </template>
        <div class="container">
          <div class="content">
            <el-form-item label="判定策略描述"
                          prop="dsDesc">
              <el-input type="textarea"
                        maxlength="500"
                        v-model="riskForm.dsDesc"></el-input>
            </el-form-item>
            <el-form-item label="扩展参数">
              <div v-for="(item, index) in riskForm.extension"
                   :key="item">
                <el-col :span="8">
                  <el-form-item label="key:">
                    <el-input v-model="riskForm.extension[index].key"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="value:">
                    <el-input v-model="riskForm.extension[index].value"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item>
                    <el-button v-if="index === 0"
                               style="margin-left: 20px"
                               @click="onAddExtension">添加</el-button>
                    <el-button v-else
                               style="margin-left: 20px"
                               icon="el-icon-delete"
                               @click="onRemoveExtension(index)"
                               type="danger"></el-button>
                  </el-form-item>
                </el-col>
              </div>
            </el-form-item>
            <el-form-item label="判定状态"
                          prop="judgeState">
              <el-switch v-model="riskForm.judgeState"
                         active-color="#13ce66"
                         inactive-color="#c2c2c2">
              </el-switch>
            </el-form-item>
          </div>
        </div>
      </el-card> -->
      <el-card style="margin-top: 20px"
               shadow="never">
        <template #header>
          <div class="card-header">执行策略</div>
        </template>
        <div class="container">
          <div class="content">
            <el-form-item label="执行策略"
                          prop="limitCode">
              <el-checkbox-group v-model="riskForm.limitCode">
                <el-checkbox v-for="item in strategyDescOptions"
                             style="display: block"
                             :label="item.label"
                             :key="item.label">
                  {{ item.key }}
                  <div class="info">
                    {{item.text}}
                  </div>
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <!-- <el-form-item label="执行状态" prop="strategyState">
              <el-switch
                v-model="riskForm.strategyState"
                active-color="#13ce66"
                inactive-color="#c2c2c2"
              >
              </el-switch>
            </el-form-item> -->
          </div>
        </div>
      </el-card>

      <el-card shadow="never"
               style="margin-top: 25px;">
        <div class="container">
          <div class="content">
            <el-form-item label="备注"
                          prop="remark">
              <el-input type="textarea"
                        maxlength="500"
                        v-model="riskForm.remark"></el-input>
            </el-form-item>

          </div>
        </div>
      </el-card>

    </el-form>
    <div slot="footer"
         class="dialog-footer">
      <el-button type="primary"
                 :disabled="saveLoading"
                 @click="onSave">保存</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import {
  updateRiskLevel
} from "@/api/security/riskLevel.js";
export default {
  props: {
    riskLevel: Object
  },
  data () {
    return {
      saveLoading: false,
      riskOptions: [{
        value: 3,
        label: '高风险'
      }, {
        value: 2,
        label: '中风险',
      }, {
        value: 1,
        label: '低风险'
      }, {
        value: 0,
        label: '无风险'
      }],
      strategyDescOptions: [{
        label: "10002",
        key: '镜像投屏需确认',
        text: '接收的镜像投屏，都需要手动确认'
      }, {
          label: "10001",
          key: '限制跨网连接',
          text: '不允许跨网投屏，包括跨网推送，跨网云镜像'
        }
      // , {
      //   label: "10004",
      //   key: '限制云镜像',
      //   text: '限制端上无法使用云镜像的功能，但仍可使用局域网镜像、投屏、讨论'
      // }, {
      //   label: "10005",
      //   key: '风险提示',
      //   text: '勾选此项，客户度触发风险提示'
      //   }
      ],
      riskForm: {
        level: '',
        dsDesc: '',
        limitName: '',
        remark: '',
        extension: [
          {
            key: "",
            value: "",
          }
        ],
        dsState: 0,
        esState: 1,
        limitCode: [], // 策略组合
      },
      limitCode: [], // 策略组合
    };
  },
  watch: {
    "$attrs.visible" (nVal) {
      console.log('===', nVal)
      if (!nVal) {
        console.log('重置')
        this.$refs.formRef.resetFields();
        console.log(this.riskForm)
      } else {
        console.log('编辑的风险等级')
        console.log(this.riskLevel)
        const data = JSON.parse(JSON.stringify(this.riskLevel))
        this.riskForm.level = data.level
        this.riskForm.dsDesc = data.dsDesc
        this.riskForm.limitName = data.limitName
        this.riskForm.remark = data.remark
        this.riskForm.limitCode = data.limitCode ? data.limitCode.split(',') : []
        console.log(this.riskForm)
      }
    }
  },
  computed: {
    formRules () {
      const rules = {
        level: { required: true, message: "请选择风险等级", trigger: "change" },
        // judgeDesc: {
        //   required: true,
        //   message: "请输入判定策略描述",
        //   trigger: "blur",
        // },
        // judgeState: { required: true },
        // strategyState: { required: true },
        // strategyDesc: {
        //   required: true,
        //   message: "请输入判定策略描述",
        //   trigger: "blur",
        // },
      };

      return rules;
    },
  },
  methods: {
    onAddExtension () {
      this.riskForm.extension.push({ key: "", value: "" });
    },
    onRemoveExtension (index) {
      this.riskForm.extension.splice(index, 1);
    },
    onSave () {
      console.log('确定')
      this.saveLoading = true
      // 根据limitcode 查找对应的strategyDescOptions中的text
      const res = this.riskForm.limitCode.map(item => {
        return this.strategyDescOptions.find(i => i.label === item).key
      })
      // 倒序数组
      // res.reverse()
      console.log("🚀 ~ res ~ res:", res)
      let saveData = {
        id: this.riskLevel.id,
        dsDesc: this.riskForm.dsDesc,
        dsExtend: JSON.stringify(this.riskForm.extension),
        dsState: this.riskForm.dsState,
        limitName: res.join(','),
        remark: this.riskForm.remark,
        limitCode: this.riskForm.limitCode.join(','),
        esState: this.riskForm.esState,
        level: this.riskForm.level
      }
      console.log('编辑的风险等级', saveData)
      updateRiskLevel(saveData).then(() => {
        this.saveLoading = false
        this.$emit("update:visible", false);
        this.$emit("reload")
      }).catch(err => {
        this.saveLoading = false
        console.log(err)
      })
    },
    cancel () {
      console.log('取消')
      this.$emit("update:visible", false)
    }
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-card__header {
  background: #f5f7fa;
}
.info {
  color: #aaa8a8;
}
.card-header {
  height: 40px;
  line-height: 40px;
}

.container {
  .title {
  }

  .subtitle {
    margin-top: 15px;
    font-size: 12px;
    color: #909399;
  }
}
</style>
